import React, { useState } from 'react'
import { List } from 'immutable'
import { ILocalizedLanguage } from 'store/locale/types'
import { useStyles } from './SmallScreenNavigation.styles'
import { Drawer } from '@material-ui/core'
import { SmallScreenNavigationBar } from './SmallScreenNavigationBar'
import { SmallScreenNavigationHeader } from './SmallScreenNavigationHeader'
import { SmallScreenNavigationItem } from './SmallScreenNavigationItem'
import { navigate } from 'hookrouter'
import { IImage } from 'hooks/useImages'
import { IMenuItem } from 'hooks/useMenu'

export interface ISmallScreenNavigationProps {
  logo: IImage
  selectedLanguage: string
  languages: List<ILocalizedLanguage>
  topMenuItems: List<IMenuItem>
  menuItems: List<IMenuItem>
  onSelectLanguage: (language: string) => void
}

interface INavigationItem {
  headerTitle: string
  menuItems: IMenuItem[]
}

export const SmallScreenNavigation = ({
  logo,
  selectedLanguage,
  languages,
  onSelectLanguage,
  menuItems,
  topMenuItems
}: ISmallScreenNavigationProps) => {
  const classes = useStyles()

  const [isOpen, setIsOpen] = useState(false)
  const [currentItem, setCurrentItem] = useState<INavigationItem>({
    headerTitle: 'home',
    menuItems: menuItems.toArray()
  })
  const [previousItems, setPreviousItems] = useState<List<INavigationItem>>(List<INavigationItem>([]))

  const onMenuItemClick = (menuItem: IMenuItem) => () => {
    if (menuItem.link) {
      if (menuItem.isExternalLink) {
        window.location.href = menuItem.link
      } else {
        navigate(menuItem.link)
        setIsOpen(false)
      }
    } else if (menuItem.items) {
      setPreviousItems(previousItems.push(currentItem))
      setCurrentItem({ headerTitle: menuItem.title, menuItems: menuItem.items })
    }
  }

  const onPreviousItemClick =
    previousItems.count() === 0
      ? undefined
      : () => {
          setCurrentItem(previousItems.last())
          setPreviousItems(previousItems.pop())
        }

  return (
    <div className={classes.root}>
      <SmallScreenNavigationBar
        logo={logo}
        selectedLanguage={selectedLanguage}
        languages={languages}
        onSelectLanguage={onSelectLanguage}
        closedOrOpenedBurger={isOpen}
        onBurgerClick={() => setIsOpen(!isOpen)}
      />
      <Drawer anchor="top" variant="persistent" open={isOpen} onClose={() => setIsOpen(false)} transitionDuration={500}>
        <div className={classes.fullList} role="presentation">
          <SmallScreenNavigationHeader onClick={onPreviousItemClick} />

          {currentItem.menuItems.map((menuItem, index) => (
            <SmallScreenNavigationItem
              key={index}
              title={menuItem.title}
              isSubMenu={menuItem.isSubMenu}
              items={menuItem.items}
              onClick={onMenuItemClick(menuItem)}
            />
          ))}

          {currentItem.headerTitle === 'home' &&
            topMenuItems.map((menuItem, index) => (
              <SmallScreenNavigationItem key={index} title={menuItem.title} onClick={onMenuItemClick(menuItem)} />
            ))}
        </div>
      </Drawer>
    </div>
  )
}
